import {
  buildCustomAttributeJsonPath,
  parseCustomAttributeJsonPath,
} from '@provision/attribute-utils';
import { JsonFieldTypeCast } from '@provision/entity-types';

// The wire path `<base>.<key><cast>` (e.g. `customAttributes.warranty_count::numeric`) is shared
// with the backend; re-exported here so grid callers keep their existing import site.
export { buildCustomAttributeJsonPath, parseCustomAttributeJsonPath };

// Display projects `::text`; the typed compare cast (filter/sort) comes from the per-type registry.
export const DISPLAY_VALUE_CAST: JsonFieldTypeCast = '::text';

// `__` keeps the column id stringToPath-safe (no `.`/`[]`) and distinct from built-in attribute names.
export const CUSTOM_ATTRIBUTE_COLUMN_ID_PREFIX = 'customAttribute__';

export function buildCustomAttributeColumnId(key: string): string {
  return `${CUSTOM_ATTRIBUTE_COLUMN_ID_PREFIX}${key}`;
}

export function isCustomAttributeColumnId(attribute: string): boolean {
  return attribute.startsWith(CUSTOM_ATTRIBUTE_COLUMN_ID_PREFIX);
}

/**
 * Display (`::text`) JSON paths for the custom-attribute columns among a set of selected grid columns.
 * These are exactly the Phase-3 `dynamicAttributePaths`; built-in columns contribute nothing, so an
 * all-built-in selection yields `[]` and the grid query stays dormant.
 */
export function getCustomAttributeDisplayPaths(
  columns: readonly { attribute: string; accessor: string }[] | null | undefined,
): string[] {
  return (columns ?? [])
    .filter((column) => isCustomAttributeColumnId(column.attribute))
    .map((column) => column.accessor);
}
